module.exports = __webpack_public_path__ + "static/img/2.0617d53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personagens/2.svg
// module id = 669
// module chunks = 0 2 3 4 5 6 7